export default __webpack_public_path__ + "static/media/Helm of the Chaos Agent.90bf96e5.jpg";